var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMasterCardLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2680_31267",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 4H4V28H28V4Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2680_31267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2442 10.1699H12.7549V21.83H19.2442V10.1699Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1674 16.0003C13.1674 13.6312 14.2798 11.5299 15.9897 10.1702C14.733 9.18141 13.1468 8.58398 11.4163 8.58398C7.31674 8.58398 4 11.9007 4 16.0003C4 20.0998 7.31674 23.4166 11.4163 23.4166C13.1468 23.4166 14.733 22.8192 15.9897 21.8303C14.2798 20.4913 13.1674 18.3694 13.1674 16.0003Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0005 16.0003C28.0005 20.0998 24.6837 23.4166 20.5841 23.4166C18.8537 23.4166 17.2674 22.8192 16.0107 21.8303C17.7412 20.4707 18.8331 18.3694 18.8331 16.0003C18.8331 13.6312 17.7206 11.5299 16.0107 10.1702C17.2674 9.18141 18.8537 8.58398 20.5841 8.58398C24.6837 8.58398 28.0005 11.9213 28.0005 16.0003Z",
    fill: "#F79E1B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCardLogo);
export default __webpack_public_path__ + "static/media/MasterCardLogo.9f4ed7e43f1d0b7fabe4261b3bb37e45.svg";
export { ForwardRef as ReactComponent };